const defaultState = {
	plants: [],
	plant: 'HUV1',
	fromDate: '',
	toDate: '',
	// searchDate: '', //add
	searchUserId: '',
	searchUserNm: '',
	resultList: [],
	groups: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
